import type { BrandImportNotImportedView } from '@mg/shared';
import { Button } from '../../../components/ui/Button';
import { Modal } from '../../../components/ui/Modal';
import { NOT_IMPORTED_COPY } from '../wizardCopy';

/**
 * "What wasn't imported" (spec:337, :351; web.md §5.5): each part of the document the import left out,
 * with why, then the audiences that did not fit beside the workspace's own (the limit of 10).
 */
export function NotImportedDialog({
  open,
  items,
  overflow,
  onClose,
  returnFocusTo,
}: {
  open: boolean;
  items: readonly BrandImportNotImportedView[];
  /** Identities of imported audiences past the limit of 10. */
  overflow: readonly string[];
  onClose: () => void;
  returnFocusTo?: HTMLElement | null;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={NOT_IMPORTED_COPY.title}
      trapFocus
      returnFocusTo={returnFocusTo}
      footer={
        <Button type="button" variant="secondary" onClick={onClose}>
          {NOT_IMPORTED_COPY.close}
        </Button>
      }
    >
      <ul className="space-y-3">
        {items.map((item, index) => (
          <li key={`item-${index}`} className="text-sm">
            <p className="font-medium text-ink">{item.section}</p>
            <p className="text-ink-muted">{item.reason}</p>
          </li>
        ))}
        {overflow.map((identity, index) => (
          <li key={`audience-${index}`} className="text-sm">
            <p className="font-medium text-ink">{identity}</p>
            <p className="text-ink-muted">{NOT_IMPORTED_COPY.audienceLimit}</p>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
